import React from 'react';
import { FormattedMessage } from 'react-intl';

import HorizontalStackBlock from 'blocks/HorizontalStackBlock';
import ItemStackBlock from 'blocks/ItemStackBlock';
import IconComponent from 'components/IconComponent';
import {
  IconNameType,
  UppercaseIconNameType
} from 'components/IconComponent/svg-sprites-info';
import Paragraph from 'components/Paragraph/Paragraph';
import Headline from 'elements/Headline';
import NakedLink from 'elements/NakedLink';
import COLORS from 'utils/constants/colors';
import { textileOrderRoute } from 'utils/history/textile-order-route';
import TextileDashboardArrowComponent from '../components/TextileDashboardArrowComponent';

export const TextileDesignBlockComponent = ({
  textileOrderId,
  activeDesignTicket,
  finishedDesignTicket,
  layout_key,
  locked
}: {
  textileOrderId: number;
  activeDesignTicket: boolean;
  finishedDesignTicket: boolean;
  locked: boolean;
  layout_key?: string
}) => {
  // const isDesignSelected = !!textileDesignSetting?.layout_key;
  // const isLocked = textileOrder.atLeastOrderStarted;

  let textileDesignState: string = 'textile design start';
  let textileDesignIcon:
    | IconNameType
    | UppercaseIconNameType
    | undefined = undefined;
  let textileDesignIconFill: keyof typeof COLORS | undefined = undefined;

  if (layout_key) {
    textileDesignState = 'textile design set';
    textileDesignIcon = 'TICK_CIRCLE';
    textileDesignIconFill = 'GREEN';
  }

  // if (textileOrder.hasActiveDesignTicket) {
  //   textileDesignState = 'textile design in progress';
  //   textileDesignIcon = 'CLOCK_CIRCLE';
  //   textileDesignIconFill = 'GRAY400';
  // }

  // if (textileOrder.hasFinishedDesignTicket) {
  //   textileDesignState = 'textile design done';
  //   textileDesignIcon = 'WARNING_CIRCLE';
  //   textileDesignIconFill = 'PRIMARY';
  // }

  if (locked) {
    return (
      <HorizontalStackBlock justified={true} gap="XS" centered={true}>
        <IconComponent
          icon="PEN_RULER"
          roundBackground="GRAY950"
          size={3.5}
          square={true}
          fill="GRAY800"
        />
        <ItemStackBlock gap="XXS">
          <Headline.Small color="GRAY560">
            <FormattedMessage id="Textile design" />
          </Headline.Small>

          <Paragraph color="GRAY560">
            <IconComponent icon="LOCK" fill="GRAY400" />
            <FormattedMessage id="Editing deactivated" />
          </Paragraph>
        </ItemStackBlock>
        <TextileDashboardArrowComponent status={'locked'} />
      </HorizontalStackBlock>
    );
  }

  return (
    <NakedLink
      to={textileOrderRoute(undefined, '/textile_design', textileOrderId)}
    >
      <HorizontalStackBlock justified={true} gap="XS" centered={true}>
        <IconComponent
          icon="PEN_RULER"
          roundBackground="PRIMARY"
          size={3.5}
          square={true}
          fill="WHITE"
        />
        <ItemStackBlock gap="XXS">
          <Headline.Small>
            <FormattedMessage id="Textile design" />
          </Headline.Small>
          <Paragraph color="TEXT_LIGHT">
            {textileDesignIcon && textileDesignIconFill && (
              <IconComponent
                icon={textileDesignIcon}
                fill={textileDesignIconFill}
              />
            )}
            <FormattedMessage id={textileDesignState} />
          </Paragraph>
        </ItemStackBlock>
        <TextileDashboardArrowComponent status={'open'} />
      </HorizontalStackBlock>
    </NakedLink>
  );
};

export default TextileDesignBlockComponent;
